import { Box, Text } from '@medly-components/core';
import { Header } from 'components';
import { MobileNavHeaderMinHeight } from 'components/common/Styled';
import styled from 'styled-components';

export const HeaderStyled = styled(Header)`
    background: ${({ theme }) => theme.colors.white};
    width: 100%;
    border-bottom: 0.1rem solid ${({ theme }) => theme.colors.grey[300]};
    @media (max-width: ${({ theme }) => theme.breakpoints.M.max}px) {
        display: none;
    }
`;

export const MapPageWrapper = styled(Box)`
    grid-area: main;
    overflow: auto;
    padding: 0;
    background: ${({ theme }) => theme.colors.grey[50]};
    display: flex;
    flex-direction: column;
    height: 100%;
    @media (max-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        height: calc(100% - ${MobileNavHeaderMinHeight});
    }
`;

export const MapContent = styled(Box)`
    display: block;
    flex: 1;
    overflow-y: auto;
    padding: 4rem 4rem 4.5rem;
    background: ${({ theme }) => theme.colors.grey[50]};
    color: ${({ theme }) => theme.colors.darkBlue};
    @media (max-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        padding: 4rem 2.4rem 4.5rem;
    }
`;

export const MapInfoHeader = styled(Text)`
    padding-bottom: 3.2rem;
`;

export const MapInfoBlueBar = styled(Text)`
    background: ${({ theme }) => theme.colors.royalBlue[100]};
    width: 100%;
    border-radius: 0.8rem;
`;

export const MapContact = styled(Text)`
    width: 100%;
    padding: 3.2rem 0 2.4rem;
    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        span {
            font-size: 1.4rem;
        }
    }
`;

export const AccordianText = styled(Text)`
    color: ${({ theme }) => theme.colors.darkBlue};
`;

export const MapTextBox = styled.div`
    padding: 2.4rem;
    padding-right: 7rem;
    border-radius: 0.8rem;
    background: ${({ theme }) => theme.colors.white};
    box-shadow: 0 0.2rem 0.8rem 0 rgba(176, 188, 200, 0.2);
    @media (max-width: ${({ theme }) => theme.breakpoints.L.min}px) {
        padding-right: 2.4rem;
    }
`;
